<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useSkillsStore } from "@/stores/skills.store";
import { useProjectShowStore } from "@/stores/projects/show.store";
import { useProjectEditStore } from "@/stores/projects/edit.store";
import { ProjectFormData } from "@/ts/interfaces";
import SideBanner from "@/components/utils/SideBanner.vue";

import ProjectForm from "@/components/client/projects/ProjectForm.vue";
import router from '@/router';

const projectId = parseInt(router.currentRoute.value.params.id)

const skillStore = useSkillsStore()
const projectEditStore = useProjectEditStore()
const projectshowStore = useProjectShowStore()

skillStore.listSkills()

const formData = ref<ProjectFormData>({
  role_title: '',
  years_of_experience: null,
  usd_hourly_rate: null,
  job_description: '',
  job_description_link: '',
  skills: [],
  complementary_skills: [],
});

const redirectOnSave = () => {
  router.push({ name: 'client-projects-index' })
}

const submitForm = async () => {
  const response = await projectEditStore.edit(projectId, formData.value)

  if(response.ok) {
    redirectOnSave()
  }
}

onMounted(async () => {
  await projectshowStore.getProjectInfo(projectId)
  const project = projectshowStore.project

  formData.value = {
    role_title: project.role_title,
    years_of_experience: project.years_of_experience,
    usd_hourly_rate: project.usd_hourly_rate,
    job_description: project.job_description,
    job_description_link: project.job_description_link,
    skills: project.skills.map(skill => skill.id),
    complementary_skills: project.complementary_skills.map(skill => skill.id),
  }
})

</script>

<template>
  <section class="project-create">
    <div class="grid-x">
      <div class="cell small-12 large-3">
        <side-banner back-route-name="client-projects-index" banner-text="Edit Project" banner-img="image-new-project.png"></side-banner>
      </div>

      <div class="cell small-12 large-8 x3large-7">
        <project-form :form-data="formData" @submit-action="submitForm"></project-form>
      </div>
    </div>
  </section>
</template>

<style lang="scss">

</style>
